import axios from "axios";

const baseURL = 'https://id.blindspot.ai/recognizer-server'
const baseApiURL = baseURL + '/api'

export default {
    login(data) {
        return axios.post(baseURL + '/login', data)
    },
    logout() {
        return axios.post(baseURL + '/logout')
    },
    tryLogin() {
        return axios.get(baseApiURL + '/try-login')
    },
    getResultSynchronous(uuid) {
        return axios.get(baseApiURL + '/get-result-synchronous', {
            params: {
                uuid
            }
        })
    },
    checkDocument({type, data, uuid}) {
        return axios.post(baseApiURL + '/check-document', data, {
            params: {
                type,
                uuid
            }
        })
    },
    detect(data) {
        return axios.post(baseApiURL + '/detect', data)
    },
    detectionResult(id) {
        return axios.get(baseApiURL + '/detection-result', {
            params: {
                id
            }
        })
    },
    upload({data, type}) {
        return axios.post(baseApiURL + '/upload', data, {
            params: {
                type
            }
        })
    },
    result(id) {
        return axios.get(baseApiURL + '/result', {
            params: {
                id
            }
        })
    }
}
